import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getStore } from '../store/Store';

/**
 * Gets the current folder pane width. Note that this is returning the width of the
 * folder pane component, which is just one part of the full left nav component.
 * @returns the number of pixels
 */
export default function getFolderPaneWidth(): number {
    const folderPaneWidth = getUserConfiguration().UserOptions.NavigationBarWidth;
    return getStore().showFolderPane ? folderPaneWidth : 0;
}
